<div class="mui-loader mui-loader--{{size}}">
  <svg class="mui-loader__rect-svg" width="206" height="206" viewBox="0 0 206 206" xmlns="http://www.w3.org/2000/svg">
    <polyline class="mui-loader__rect" id="Path" stroke="#979797" stroke-width="4" points="103.762991 3.12647724 203.762991 102.904952 103.762991 202.683427 3.7629905 102.904952 105.180239 1.72262526"></polyline>
  </svg>
</div>
